import { countMessagesReceivedByHourOfWeek } from '../queries/countMessagesReceivedByHourOfWeek'

export const messagesReceivedByHourOfWeekGauge = {
  id: 'messagesReceivedByHourOfWeekGauge',
  queries: [countMessagesReceivedByHourOfWeek],
  title: 'Busiest Hours of The Day',
}
